interface SparklesLogoProps {
  size?: number;
  className?: string;
}

export default function SparklesLogo({ size = 48, className = '' }: SparklesLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="sparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#e040fb" />
          <stop offset="50%" stopColor="#7c4dff" />
          <stop offset="100%" stopColor="#536dfe" />
        </linearGradient>
      </defs>
      {/* Large star */}
      <path
        d="M28 4C28 4 31 16 32 20C33 24 44 28 44 28C44 28 33 31 32 34C31 37 28 48 28 48C28 48 25 37 24 34C23 31 12 28 12 28C12 28 23 25 24 20C25 16 28 4 28 4Z"
        fill="url(#sparkleGradient)"
      />
      {/* Small star */}
      <path
        d="M12 2C12 2 13.5 7 14 9C14.5 11 19 12.5 19 12.5C19 12.5 14.5 14 14 16C13.5 18 12 23 12 23C12 23 10.5 18 10 16C9.5 14 5 12.5 5 12.5C5 12.5 9.5 11 10 9C10.5 7 12 2 12 2Z"
        fill="url(#sparkleGradient)"
        opacity="0.7"
      />
      {/* Tiny star */}
      <path
        d="M10 30C10 30 10.8 33 11 34C11.2 35 14 35.5 14 35.5C14 35.5 11.2 36.2 11 37C10.8 38 10 41 10 41C10 41 9.2 38 9 37C8.8 36 6 35.5 6 35.5C6 35.5 8.8 35 9 34C9.2 33 10 30 10 30Z"
        fill="url(#sparkleGradient)"
        opacity="0.5"
      />
    </svg>
  );
}
